export enum NonEmployeePickupWarnStatus {
  NOT_PICKED_UP = 'EMPLOYEE_NOT_PICKED_UP',
  IN_TRANSIT = 'EMPLOYEE_IN_TRANSIT',
  DROPPED_OFF = 'EMPLOYEE_DROPPED_OFF',
  NA = 'N/A'
}
